import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import type { ApReceipt } from "@/accounts-payable/types";

export const vendorCol: ColumnDef<ApReceipt> = {
  id: "vendor",
  header: "Store",
  accessorFn: (row) => row.vendor_name,
  meta: { size: "240px" },
  cell: ({ row }) => (
    <Stack align="start" gap={1}>
      <span className="font-medium">{row.original.vendor_name}</span>
      {row.original.po_number && (
        <span className="text-xs text-subtle">
          PO / job: {row.original.po_number}
        </span>
      )}
    </Stack>
  ),
};
